import reduce from 'lodash/reduce';
import get from 'lodash/get';
import each from 'lodash/each';

import {
  isGridPositionsContentSection, 
  getContentUuids
} from 'zoomforth_codesbane_viewer/lib/sections.js';


/*
  convert a mapping of sections by id to a mapping of
  sections by the page content item uuids which belong in those sections
*/
const makeSectionByPageContentUuid = (sectionsById)=> {
  const sectionByPageContentUuid = {};
  each(sectionsById, section => {
    each(getContentUuids(section), uuid => {
      sectionByPageContentUuid[uuid] = section;
    });
  });
  return sectionByPageContentUuid;
};


/*
  Given a pageContentItem, if it has a `shouldOpenOverlay` which points at a section
  which *cannot* open in overlay, then return a copy of that page content item
  with `shouldOpenOverlay` set to false. Otherwise return the original page content item
*/
const sanitizePageContentItem = (pageContentItem, { getSectionIdByPageContentUuid })=> {

  if (!get(pageContentItem, 'tile_action_data.shouldOpenOverlay', false)) {
    // This content doesnt open in overlay; ignore it
    return pageContentItem;
  }

  // This content does open in overlay we want to make sure thats actually valid
  const section = getSectionIdByPageContentUuid()[get(pageContentItem, 'tile_action_data.contentUuid')];

  if (!section) {
    // Something is probably broken, ignore it
    // (It's not responsibility of this transformation to remove bad sections/content items)
    return pageContentItem;
  }

  if (isGridPositionsContentSection(section)) {
    // This section does support opening in an overlay, 
    return pageContentItem;
  }

  // This section does not support overlays
  return {
    ...pageContentItem,
    tile_action_data: {
      ...pageContentItem.tile_action_data,
      shouldOpenOverlay: false // replace should open overlay with false
    }
  };
};


/*
  Return pageContentItemsByUuid without invalid `shouldOverOverlay`s set
*/
export default (pageContentItemsByUuid, { sectionsById })=> {

  // We do a lazy get and buid of the page content to section id mapping until 
  // we know for sure we really need it
  var _sectionsByPageContentUuid;
  const getSectionIdByPageContentUuid = ()=> {
    if (!_sectionsByPageContentUuid) {
      _sectionsByPageContentUuid = makeSectionByPageContentUuid(sectionsById);
    }
    return _sectionsByPageContentUuid;
  };

  return reduce(pageContentItemsByUuid, (accum, pageContentItem, uuid)=> (

    {
      ...accum,
      [uuid]: sanitizePageContentItem(pageContentItem, { getSectionIdByPageContentUuid })
    }

  ), {});

};